if (!customElements.get("media-gallery")) {
  customElements.define(
    "media-gallery",
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia("(min-width: 750px)");
        if (!this.elements.thumbnails) return;

        this.previousImage = this.querySelector(".previous-image");
        this.nextButton = this.querySelector(".next");
        this.prevButton = this.querySelector(".prev");

        setTimeout(() => {
          if (this.nextButton) {
            this.nextButton.addEventListener(
              "click",
              this.onNextButton.bind(this)
            );
          }

          if (this.prevButton) {
            this.prevButton.addEventListener(
              "click",
              this.onNextButton.bind(this)
            );
          }

          this.setActiveMedia(
            this.elements.thumbnails.children[1].firstElementChild.dataset
              .target
          );
        }, 500);

        this.elements.viewer
          .querySelector(".product__media-list")
          .addEventListener("mouseenter", this.setPreviousImage.bind(this));

        this.elements.viewer
          .querySelector(".product__media-list")
          .addEventListener("mouseleave", this.revertBackToOGImage.bind(this));

        this.elements.viewer.addEventListener(
          "slideChanged",
          debounce(this.onSlideChanged.bind(this), 500)
        );

        this.elements.thumbnails
          .querySelectorAll("[data-target]")
          .forEach((mediaToSwitch) => {
            mediaToSwitch
              .querySelector("button")
              .addEventListener(
                "click",
                this.setActiveMedia.bind(
                  this,
                  mediaToSwitch.dataset.target,
                  false
                )
              );
          });
        if (
          this.dataset.desktopLayout.includes("thumbnail") &&
          this.mql.matches
        )
          this.removeListSemantic();
      }

      setPreviousImage(event) {
        // if (
        //   event.explicitOriginalTarget.classList.contains("navigation-button")
        // )
        //   return;

        const currentActiveMedia =
          this.elements.viewer.querySelector(".is-active").dataset.mediaId;

        this.previousImage.dataset.og = currentActiveMedia;

        this.setActiveMedia(this.previousImage.dataset.src, false, true);
      }

      revertBackToOGImage(event) {
        if (this.previousImage.dataset.og.length > 0) {
          this.setActiveMedia(this.previousImage.dataset.og, false, true);
        }
      }

      onNextButton(event) {
        if (event.target.dataset.target) {
          this.setActiveMedia(event.target.dataset.target);
        }
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend, hover = false) {
        const activeMedia = this.elements.viewer.querySelector(
          `[data-media-id="${mediaId}"]`
        );

        this.elements.viewer
          .querySelectorAll("[data-media-id]")
          .forEach((element) => {
            element.classList.remove("is-active");
          });

        activeMedia.classList.add("is-active");

        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(
              `[data-target="${mediaId}"]`
            );
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();

        window.setTimeout(() => {
          if (this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({
              left: activeMedia.offsetLeft,
            });
          }
          if (
            !this.elements.thumbnails ||
            this.dataset.desktopLayout === "stacked"
          ) {
            activeMedia.scrollIntoView({ behavior: "smooth" });
          }
        });

        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;

        const activeThumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${mediaId}"]`
        );

        if (hover === false) {
          if (activeThumbnail.nextElementSibling) {
            this.nextButton.dataset.target =
              activeThumbnail.nextElementSibling.dataset.target;
          } else {
            this.nextButton.dataset.target =
              activeThumbnail.parentElement.firstElementChild.dataset.target;
          }

          if (activeThumbnail.previousElementSibling) {
            this.prevButton.dataset.target =
              activeThumbnail.previousElementSibling.dataset.target;
          } else {
            this.prevButton.dataset.target =
              activeThumbnail.parentElement.children[
                activeThumbnail.parentElement.children.length - 1
              ].dataset.target;
          }
        }

        this.setActiveThumbnail(activeThumbnail);

        this.announceLiveRegion(
          activeMedia,
          activeThumbnail.dataset.mediaPosition
        );
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll("button")
          .forEach((element) => element.removeAttribute("aria-current"));
        thumbnail.querySelector("button").setAttribute("aria-current", true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({
          left: thumbnail.offsetLeft,
        });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector(
          ".product__modal-opener--image img"
        );
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute("aria-hidden", false);
          this.elements.liveRegion.innerHTML =
            window.accessibilityStrings.imageAvailable.replace(
              "[index]",
              position
            );
          setTimeout(() => {
            this.elements.liveRegion.setAttribute("aria-hidden", true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector(".deferred-media");
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader =
          this.stickyHeader || document.querySelector("sticky-header");
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event("preventHeaderReveal"));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute("role", "presentation");
        this.elements.viewer.sliderItems.forEach((slide) =>
          slide.setAttribute("role", "presentation")
        );
      }
    }
  );
}
